"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _preactPortal = _interopRequireDefault(require("preact-portal"));

function NavigationHeader(props) {
  var title = props.title,
      isBeta = props.isBeta;
  return (0, _preact.h)(_preactPortal.default, {
    into: ".top-navigation-page_title"
  }, (0, _preact.h)("div", {
    className: "page-title"
  }, (0, _preact.h)("div", {
    className: "page-title-text"
  }, title, isBeta && (0, _preact.h)("span", {
    className: "beta-label-secondary"
  }, "BETA"))));
}

var _default = NavigationHeader;
exports.default = _default;